import { Entity } from '@/store/shared/entity'

export default class ContainerShipmentStatistics extends Entity<number>{
    chargeUserId:number;
    chargeUser:string;
    totalLCL:number;
    logisticsName:string;
    _40HQ:number;
    _45HQ:number;
    _20GP:number;
    _40GP:number;
    total40HQ:number;
    total45HQ:number;
    total20GP:number;
    total40GP:number;
    totalWholeCabinetStatistics:number;

}